import { render, staticRenderFns } from "./SubjectCertsDropDown.vue?vue&type=template&id=94de6eda&scoped=true&"
import script from "./SubjectCertsDropDown.vue?vue&type=script&lang=js&"
export * from "./SubjectCertsDropDown.vue?vue&type=script&lang=js&"
import style0 from "./SubjectCertsDropDown.vue?vue&type=style&index=0&id=94de6eda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94de6eda",
  null
  
)

export default component.exports